module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/5-e7bb7d53cf67fd80a23bb9e7a396c9df.jpg";